import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoadingSpinnerComponent } from '@components';
import { GknRoutePath } from '../app-routing.enum';

@Component({
    selector: 'app-sso-callback',
    standalone: true,
    imports: [CommonModule, LoadingSpinnerComponent, RouterModule],
    templateUrl: './sso-callback.component.html',
    styleUrls: ['./sso-callback.component.scss'],
})
export class SsoCallbackComponent implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    ngOnInit(): void {
        this.route.queryParams.subscribe((params: any) => {
            if (params.code) {
                // Amplify processes the auth code automatically when getCurrentUser is called
                // TODO
            } else if (params.error) {
                console.error('SAML auth error:', params.error);
                this.router.navigate([`/${GknRoutePath.HOME}`]);
            } else {
                this.router.navigate([`/${GknRoutePath.HOME}`]);
            }
        });
    }
}
